import {ServiceBase} from '../ServiceBase';
import {IWebVitalsService} from "./web-vitals.service.interface";

interface ILCPData{
    loadTimeAsNumber:number;
    renderTimeAsNumber:number;
    url:string;
}

interface IFIDData{
    className:string;
    startTimeAsNumber:number;
    duration:number;
    name:string;
}

interface ICLSData{
    bigestShift:number;
    bigShiftElements:Array<string>;
    shiftCounter:Object;
}
export class WebVitalsService extends ServiceBase implements IWebVitalsService {
    private _siteNavCLSReported: boolean = false;
    private _reportedCLSPages:Array<string> = [];
    private static STORAGE_NAME = "orbitWebVitals";

    siteFinishedLoading(): void {

            setTimeout(() => {
                    try {
                        this._reportLCP();
                    } catch (err) {
                        this.services.logger.warning("WeVitals siteFinishedLoading warning: " + err);
                    }
                },
                3000);
    }

    leavingPage(lastRoute:string){
        try {
            if(this._reportedCLSPages.indexOf(lastRoute)!==-1)return;
            this._logCustomObjectToElastic(this._siteNavCLSReported ? "PAGE_NAV_CLS" : "SITE_NAV_CLS", lastRoute, WebVitalsService._clsData, WebVitalsService._cls.toFixed(3));
            this._reportedCLSPages.push(lastRoute);
            (!this._siteNavCLSReported) && (this._siteNavCLSReported = true);
            WebVitalsService._resetCLSData();
        }
        catch (err) {
            this.services.logger.warning("WeVitals leavingPage warning: " + err);
        }
    }

    private _reportLCP(){
        (WebVitalsService._lcpData?.loadTimeAsNumber>0) && this._logCustomObjectToElastic("LCP", window.location.pathname, WebVitalsService._lcpData);
    }

    private _logCustomObjectToElastic(eventAction:string, eventLabel:string, orbitWebVitalsData: ILCPData | IFIDData | ICLSData, eventValue:string=null) {
        let customData = this._prepareCustomData(orbitWebVitalsData);

        this.services.sdk.structuredLoggingService
            .getLogger()
            .addCategory("ORBIT_WEB_VITALS")
            .addAction(eventAction)
            .addLabel(eventLabel)
            .addValue(eventValue)
            .addCustomData(customData)
            .info();
    }

    private _prepareCustomData(orbitWebVitalsData):ILCPData | IFIDData | ICLSData {
        let customData = {...orbitWebVitalsData};
        if(customData["bigestShift"]===0){
            customData = null;
        }
        else{
            const SHIFT_COUNTER = "shiftCounter";
            if(customData && customData[SHIFT_COUNTER]){
                if(Object.keys(customData[SHIFT_COUNTER]).length) {
                    const topShiftsCount = Object.keys(customData[SHIFT_COUNTER]);
                    try {
                        topShiftsCount.sort(function(a, b){return customData[SHIFT_COUNTER][b]-customData[SHIFT_COUNTER][a]}).slice(0,1);
                        if(customData[SHIFT_COUNTER][topShiftsCount[0]] === customData[SHIFT_COUNTER][topShiftsCount[1]]){
                            topShiftsCount.sort();
                            customData[SHIFT_COUNTER+"sEqual"] = true;
                        }
                        customData[SHIFT_COUNTER+"1st"] = topShiftsCount[0];
                        topShiftsCount[1] && (customData[SHIFT_COUNTER+"2nd"] = topShiftsCount[1]);
                    }
                    catch (errDetails){};
                }
                delete customData[SHIFT_COUNTER];
            }
        }
        return customData;
    }

    private static get _lcpData():ILCPData
    {
        return window[WebVitalsService.STORAGE_NAME]?.lcp;
    }
    private static get _cls():number {
        return window[WebVitalsService.STORAGE_NAME]?.cls;
    }

    private static get _clsData():ICLSData {
        return window[WebVitalsService.STORAGE_NAME]?.clsElements;
    }

    private static _resetCLSData(){
        window[WebVitalsService.STORAGE_NAME].clsElements = {bigestShift:0.0, bigShiftElements:[], shiftCounter: {}};
        window[WebVitalsService.STORAGE_NAME].cls = 0.0;
    }

}
